<div class="st-anchor-command-dialog__body">
    <st-text-field
        showLinks
        [label]="languageSettings()?.[ProductionCommandFieldsLabelKeys[ProductionFieldName.ANCHOR]]"
        [value]="commands()?.[0]?.[ProductionFieldName.TEXT]"
        (enter)="onEnterSaveCommand($event, ProductionCommandType.ANCHOR)"
        (changed)="onCommandsObjectChange($event, ProductionCommandType.ANCHOR)" />

    <st-text-field
        showLinks
        [label]="languageSettings()?.[ProductionCommandFieldsLabelKeys[ProductionFieldName.READRATE]]"
        [value]="commands()?.[1]?.[ProductionFieldName.TEXT]"
        (enter)="onEnterSaveCommand($event, ProductionCommandType.READRATE)"
        (changed)="onCommandsObjectChange($event, ProductionCommandType.READRATE)" />
</div>
